import axios from 'axios'
import helpers from './../../helpers'

export default {
    getEvents({commit}, page = 1) {

        axios.get(process.env.VUE_APP_API_URL + `/event?page=${page}`)
            .then(response => {
                commit('storeEvents', response.data.data)
            })
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    getEventById({commit}, id) {

        axios.get(process.env.VUE_APP_API_URL + `/event/${id}`)
            .then(response => {
                commit('storeEvent', response.data.data)
            })
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    storeEvent({commit}, event) {

        axios.put(process.env.VUE_APP_API_URL + `/event/${event.id}`, event)
            .then(() => {
                helpers.handleSuccessMessage("Der Termin wurde gespeichert.", "Gespeichert")
                window.location = '/Termine'
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Termin wurde nicht gespeichert.", "Fehler!")
            })

        commit('none')
    },
    createEvent({commit}, event) {

        axios.post(process.env.VUE_APP_API_URL + `/event`, event)
            .then(() => {
                helpers.handleSuccessMessage("Der Termin wurde erstellt.", "Erstellt")
                window.location = '/Termine'
                commit('resetNewEvent')
            }).catch(exception => {
            helpers.handleMildAxiosError(exception)
        })
    },
    deleteEvent({ commit }, eventId) {
        axios.delete(process.env.VUE_APP_API_URL + `/event/${eventId}`)
            .then(() => {
                helpers.handleSuccessMessage("Der Termin wurde gelöscht.")
                commit('clearEvents')
                window.location = "/Termine"
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Termin konnte nicht gelöscht werden.")
            })
    },
    getCalendarById({commit}, id) {

        axios.get(process.env.VUE_APP_API_URL + `/calendar/${id}`)
            .then(response => {
                commit('storeCalendar', response.data.data)
            })
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    getCalendars({commit}) {

        axios.get(process.env.VUE_APP_API_URL + `/calendar`)
            .then(response => {
                commit('storeCalendars', response.data.data)
            })
            .catch(() => {
                helpers.handleWarningMessage("Die Kalender konnten nicht geladen werden.")
            })
    },
    /* eslint-disable-next-line no-empty-pattern */
    storeCalendar({}, calendar) {
        axios.put(process.env.VUE_APP_API_URL + `/calendar/${calendar.id}`, calendar)
            .then(() => {
                helpers.handleSuccessMessage("Die Kategorie wurde gespeichert.", "Gespeichert")
                window.location = '/Termine'
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Kalender konnte nicht gespeichert werden.")
            })
    },
    createCalendar({commit}, calendar) {
        axios.post(process.env.VUE_APP_API_URL + `/calendar`, calendar)
            .then(() => {
                helpers.handleSuccessMessage("Der Kalender wurde erstellt.", "Erstellt")
                window.location = '/Termine'
                commit('resetNewCalendar')
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Kalender konnte nicht erstellt werden.")
            })
    },
    deleteCalendar({ commit }, calendarId) {
        axios.delete(process.env.VUE_APP_API_URL + `/calendar/${calendarId}`)
            .then(() => {
                helpers.handleSuccessMessage("Der Kalender wurde gelöscht.")
                commit('clearCalendars')
                window.location = "/Termine"
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Kalender konnte nicht gelöscht werden.")
            })
    }
}
